module.exports = __webpack_public_path__ + "img/ryan.b2cd19c3.svg";